import Vue from 'vue';
import Vuex from 'vuex';

//import createPersistedState from "vuex-persistedstate";





import system from './modules/system.js';
import userData from './modules/userData.js';
import projects from './modules/projects.js';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        system,
        userData,
        projects
    }//,
    //plugins: [ createPersistedState() ]
});
